import styles from "./PauseSubscriptionModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";
import { subscriptionData } from "../../../types/details-api-types";
import { useUpdateSubscriptionMutation } from "../../../store/services/auth-api";
import { useState } from "react";
import { trackEvent } from "../../../utils/analytics";
import { EVENT_NAMES } from "../../../types/event-names";

interface PauseSubscriptionModalProps {
  setIsModalPauseSubVisible: (arg: boolean) => void;
  setIsModalPauseConfirmVisible: (arg: boolean) => void;
  subscriptionItem?: subscriptionData | null;
  refetch: () => void;
}

const PauseSubscriptionModal: React.FC<PauseSubscriptionModalProps> = ({
  setIsModalPauseSubVisible,
  setIsModalPauseConfirmVisible,
  subscriptionItem,
  refetch,
}) => {
  const { t } = useTranslation();

  const [updateSubscription] = useUpdateSubscriptionMutation();
  const [isLoader, setIsLoader] = useState(false);

  const showProcessingModal = async () => {
    setIsLoader(true);

    trackEvent(EVENT_NAMES.SUBSCRIPTION_PAUSED_CONFIRMED, {
      subscriptionId: subscriptionItem?.subscription_id,
      parameter: "CONFIRMED",
    });

    await updateSubscription({ subscription_id: subscriptionItem?.subscription_id, status: true })
      .unwrap()
      .then((payload) => {

        setTimeout(() => {
          setIsModalPauseConfirmVisible(true);
          setIsModalPauseSubVisible(false);
          refetch();
        }, 2000);

        trackEvent(EVENT_NAMES.SUBSCRIPTION_PAUSED_SUCCESS, {
          subscriptionId: subscriptionItem?.subscription_id,
          parameter: "SUCCESS",
        });
      })
      .catch((error) => {
        console.error(error);
        setIsModalPauseSubVisible(false);

        trackEvent(EVENT_NAMES.SUBSCRIPTION_PAUSED_FAILED, {
          subscriptionId: subscriptionItem?.subscription_id,
          parameter: "FAILED",
        });
      })
      .finally(() => {
        setIsLoader(false);
      });
  };

  trackEvent(EVENT_NAMES.SUBSCRIPTION_PAUSED_INITIATED, {
    subscriptionId: subscriptionItem?.subscription_id,
    parameter: "PAUSED",
  });

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{t("Are You Sure You Want to Pause Your Subscription?")}</p>
        <div className={styles.root_header_imgBlock}>
          <img
            src={close}
            alt="close"
            onClick={() => {
              trackEvent(EVENT_NAMES.SUBSCRIPTION_PAUSED_KEEP);
              setIsModalPauseSubVisible(false);
            }}
            className={styles.root_header_img}
          />
        </div>
      </div>
      <p className={styles.root_subtitle}>
        {t(
          "Pausing your subscription will stop automatic renewals, but you will still have access to all Fortect features until the end of your current billing period. You can easily resume your subscription anytime."
        )}
      </p>
      <div className={styles.root_buttons}>
        <Button
          onClick={() => {
            showProcessingModal();
          }}
          text={t("Confirm Pause")}
          classNames={styles.root_button}
          isLoader={isLoader}
        />
        <Button
          onClick={() => {
            trackEvent(EVENT_NAMES.SUBSCRIPTION_PAUSED_KEEP);
            setIsModalPauseSubVisible(false);
          }}
          text={t("Keep My Subscription")}
          type="default"
          classNames={styles.root_button}
        />
      </div>
    </div>
  );
};

export default PauseSubscriptionModal;
